var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFactoryModule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 77,
    viewBox: "0 0 94 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4515 31.1861H83.5547V1.5354H70.287V42.3052L51.1225 32.0757V42.3052L33.4322 32.0757V42.3052L17.2161 32.0757V42.3052L3.94838 32.0757C2.32677 32.0757 1 33.4099 1 35.0407V72.8454C1 74.4762 2.32677 75.8105 3.94838 75.8105H89.4515C91.0731 75.8105 92.3999 74.4762 92.3999 72.8454V34.2995C92.3999 32.5204 91.0731 31.1861 89.4515 31.1861Z",
    stroke: "#021472",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7932 48.9766H6.89648V54.9067H12.7932V48.9766Z",
    stroke: "#021472",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5345 48.9766H21.6377V54.9067H27.5345V48.9766Z",
    stroke: "#021472",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7532 48.9766H37.8564V54.9067H43.7532V48.9766Z",
    stroke: "#021472",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4505 48.9766H55.5537V54.9067H61.4505V48.9766Z",
    stroke: "#021472",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 69.8813H92.3999",
    stroke: "#021472",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactoryModule);
export default __webpack_public_path__ + "static/media/factoryModule.205b15fa4d8a37e7c1304f7c3e6f472b.svg";
export { ForwardRef as ReactComponent };